import React from 'react';

import { AlertRow } from '../../../../entities/Alert';
import getWhatsappLink from '../../../../utils/getWhatsappLink';

import { WhatsappButton } from '../styles';

interface WhatsappActionProps {
  alert: AlertRow;
}

/**
 * O botão de WhatsApp da linha e do informativo — um componente só, porque a regra
 * de desabilitar **com explicação** (`getWhatsappLink`) tem de valer igual nos dois.
 *
 * ⚠️ **O clique é barrado no `onClick`, e não com `pointer-events: none`.** Era assim
 * até 2026-09-30, e o `pointer-events` matava também o passar do mouse: o `title`
 * com o motivo nunca aparecia e o botão ficava cinza sem explicação (achado 8 do QA
 * de 18/09).
 */
const WhatsappAction: React.FC<WhatsappActionProps> = ({ alert }) => {
  const whatsappLink = getWhatsappLink(alert.whatsapp, alert.hasActiveWhatsapp);

  return (
    <WhatsappButton
      href={whatsappLink ?? undefined}
      target="_blank"
      rel="noreferrer"
      aria-disabled={!whatsappLink}
      onClick={(event) => {
        if (!whatsappLink) {
          event.preventDefault();
        }
      }}
      title={
        whatsappLink
          ? 'Falar com o paciente no WhatsApp'
          : 'Paciente sem WhatsApp verificado'
      }
    >
      WhatsApp
    </WhatsappButton>
  );
};

export default WhatsappAction;
